export var getActiveElement = function () {
    var focusedElement = (document.hasFocus() &&
        document.activeElement !== document.body &&
        document.activeElement !== document.documentElement &&
        document.activeElement) || null;
    return focusedElement;
};
export var isVisible = function (element) {
    return element.offsetWidth === 0 && element.offsetHeight === 0;
};
export var focusableElements = "\n    a[href]:not(.u-hidden, [disabled]),\n    button:not(.u-hidden, [disabled]),\n    textarea:not(.u-hidden, [disabled]),\n    input[type=\"text\"]:not(.u-hidden, [disabled]),\n    input[type=\"radio\"]:not(.u-hidden, [disabled]),\n    input[type=\"checkbox\"]:not(.u-hidden, [disabled]),\n    select:not(.u-hidden, [disabled]),\n    summary:not(.u-hidden, [disabled]),\n    [tabIndex=\"0\"]:not(.u-hidden, [disabled])\n";
// factory method that returns a focus trap method that can e used to remove the event listener later.
export var focusTrapHandler = function (_a) {
    var element = _a.element, classNames = _a.classNames;
    var customQuerySelectors = '';
    // were only ever interested in focusing elements that are visible, and not disabled.
    classNames && classNames.forEach(function (className, index) {
        customQuerySelectors += "".concat(className, ":not(.u-hidden, [disabled])");
        if (index !== classNames.length - 1)
            customQuerySelectors += ',';
    });
    var querySelectors = customQuerySelectors || focusableElements;
    var focusTrap = function (event) {
        var focusableElements = Array.from(element.querySelectorAll(querySelectors));
        var filteredFocusableElements = focusableElements.filter(function (focusableElement) {
            return !isVisible(focusableElement);
        });
        var firstFocusableEl = filteredFocusableElements[0];
        var lastFocusableEl = filteredFocusableElements[filteredFocusableElements.length - 1];
        var KEYCODE_TAB = 9;
        var currentActiveElement = getActiveElement();
        if (event.key === 'Tab' || event.keyCode === KEYCODE_TAB) {
            if (event.shiftKey) /* shift + tab */ {
                if (currentActiveElement === firstFocusableEl) {
                    lastFocusableEl.focus();
                    if (event.cancelable) {
                        event.preventDefault();
                    }
                }
            }
            else /* tab */ {
                if (currentActiveElement === lastFocusableEl) {
                    firstFocusableEl.focus();
                    if (event.cancelable) {
                        event.preventDefault();
                    }
                }
            }
        }
    };
    return focusTrap;
};
